import React from "react";
import formatCpf from "@brazilian-utils/format-cpf";

import { cpfCnpjCursorAlign, validateCNPJ, validateCPF } from "utils/functions";
import {
  formatDocumentForDisplay,
  isDocumentLengthInvalid,
  sanitizeDocument,
} from "utils/formatting/document";

export const applyCpfCnpjInputMask = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
): void => {
  const cursorStart = event.target.selectionStart;
  const cursorEnd = event.target.selectionEnd;
  const s = sanitizeDocument(event.target.value);
  if (s.length <= 11) {
    const digitOnly = s.replace(/[^0-9]/g, "").slice(0, 11);
    event.target.value = digitOnly.length > 0 ? formatCpf(digitOnly) : "";
  } else {
    event.target.value = formatDocumentForDisplay(s.slice(0, 14));
  }
  cpfCnpjCursorAlign(event, cursorStart, cursorEnd);
};

export const getCpfCnpjLoginFieldError = (
  value: string | undefined
): string | undefined => {
  if (!value) {
    return "É obrigatório preencher seus dados!";
  }
  const s = sanitizeDocument(value);
  if (isDocumentLengthInvalid(value)) {
    if (s.length > 14) {
      return "Insira um tamanho válido para o documento";
    }
    if (s.length >= 12 && s.length <= 13) {
      return "Insira um CNPJ válido";
    }
    if (s.length >= 1 && s.length <= 10) {
      return "Insira um CPF válido";
    }
    if (s.length === 11 && /[^0-9]/.test(s)) {
      return "Insira um CPF válido";
    }
    return "Insira um CPF válido";
  }
  if (s.length === 11 && /^\d{11}$/.test(s) && !validateCPF(s)) {
    return "Insira um CPF válido";
  }
  if (s.length === 14 && !validateCNPJ(s)) {
    return "Insira um CNPJ válido";
  }
  return undefined;
};
